import React from 'react';
import PropTypes from 'prop-types';

export const FranchisePageLayout = ({ children }) => {
  return (<div id="FranchisePage">{children}</div>)
};

FranchisePageLayout.propTypes = {
  children: PropTypes.any
}